export default "__VITE_ASSET__OmcjtVJI__"